import React, { PropsWithChildren, useEffect } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

import { AuthRuntimeConfig, getAuthConfigurationError, loginRequest } from './msalConfig';

interface AuthGateProps extends PropsWithChildren {
    authConfig: AuthRuntimeConfig;
}

export function AuthGate({ authConfig, children }: AuthGateProps) {
    const { accounts, inProgress, instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const configurationError = getAuthConfigurationError(authConfig);

    useEffect(() => {
        if (!instance.getActiveAccount() && accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
        }
    }, [accounts, instance]);

    useEffect(() => {
        if (configurationError || isAuthenticated || inProgress !== InteractionStatus.None) {
            return;
        }

        instance.loginRedirect(loginRequest);
    }, [configurationError, inProgress, instance, isAuthenticated]);

    if (configurationError) {
        return <div>{configurationError}</div>;
    }

    if (!isAuthenticated || inProgress !== InteractionStatus.None) {
        return <div>Signing you in...</div>;
    }

    return <>{children}</>;
}
